import asyncFetch from '../utils/asyncFetch';

const resendConfirmationEmail = async ({ email, token, throwOnError }) => {
  try {
    const { resent } = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/auth/send-email-confirmation`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: {
        email,
      },
    });
    return resent;
  } catch (error) {
    console.log(error);
    if (throwOnError) {
      throw error;
    }
  }
};

export default resendConfirmationEmail;
